import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledTableCell } from "../../../ui-components/StyledTables";
import { useSuperAdminSuscripts } from "../../../context/SuperAdmin/SuscriptsContext";
import { ProfileRowSuscriptOrg } from "./ProfileRowSuscriptOrg";

const SuscriptsTable = () => {
  const { suscriptions, searchText } = useSuperAdminSuscripts();

  // Filtro de usuarios por búsqueda
  const normalizedSearch = searchText.toLowerCase().trim();
  const filteredSuscr = suscriptions.filter((suscr) => {
    return suscr.plan.toLowerCase().includes(normalizedSearch);
  });
  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            <StyledTableCell>N°</StyledTableCell>
            <StyledTableCell>Plan</StyledTableCell>
            <StyledTableCell>Fecha de creación</StyledTableCell>
            <StyledTableCell>Fecha de inicio</StyledTableCell>
            <StyledTableCell>Fecha de expiración</StyledTableCell>
            <StyledTableCell>Estado</StyledTableCell>
            <StyledTableCell align="center">Acciones</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredSuscr?.length > 0 ? (
            filteredSuscr?.map((suscr, index) => (
              <ProfileRowSuscriptOrg
                key={suscr.id_suscripcion}
                suscription={suscr}
                i={index + 1}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SuscriptsTable;
